import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=c426b16c&scoped=true"
import script from "./EmojiPicker.vue?vue&type=script&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=c426b16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c426b16c",
  null
  
)

export default component.exports